import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import api from "../../../../api";
import functions from "../../../../functions";
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js";
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

import './styles.css';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      Actividad: "",
      Detalle:"",
      FUA:null,
      postVariables: [],
      errors: [],
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    id: PropTypes.func,
    action: PropTypes.oneOf(['DETAIL']).isRequired,
  }

  resetForm() {
    this.setState({
      id: null,
      Actividad: "",
      Detalle:"",
      FUA:null,
      errors: [],
    });
  }

  getData() {
    const { postVariables } = this.state;
    let data = {};
    postVariables.forEach(x => {
      data[x] = this.state[x];
    });
    return data;
  }

  setData(data) {
    if (data.success) {
      this.setState({
        id: data.id,
        Actividad: data.Actividad,
        Detalle:data.Detalle,
        FUA: functions.FormatDate(data.FUA),
      })
    }
  }

  setErrors(errors) {
    this.setState({
      errors: errors,
    });
  }

  onChangeField(field, value) {
    this.setState(prevState => {
      let errors = prevState.errors;
      if (errors) errors[field] = null;
      prevState.errors = errors;
      prevState[field] = value;
      return prevState;
    });
  }

  getError(field) {
    let errors = this.state.errors;
    if (errors) return errors[field];
    else return null;
  }

  modalVars() {
    const { action } = this.props;
    if (action == "DETAIL") {
      return {
        get: true,
        submitType: null,
        title: `Actividad realizada el ${this.state.FUA}`,
        buttonTitle: "Ver",
        danger: false,
        buttonIcon: "fa fa-search fa-lg",
        successMessage: "",
        saveButton: false,
        buttonClass: "",
        disabled: true,
        id: this.props.id,
      };
    }
  }

  render() {
    let vars = this.modalVars();

    return (
      <ParadigmaModal
        getUrl={(vars.get ? api.gestion.core.bitacoras : null)}
        submitUrl={(vars.submitType ? api.gestion.core.bitacoras : null)}
        submitType={vars.submitType}
        id={vars.id}

        className="modal-xl"

        onGotData={(data) => this.setData(data)}
        onGotErrors={(errors) => this.setErrors(errors)}
        onSubmit={(e) => this.props.onSubmit(e)}
        onClose={() => this.resetForm()}
        onPreSubmit={() => this.getData()}

        title={vars.title}

        danger={vars.danger}
        buttonClass={vars.buttonClass}

        successMessage={vars.successMessage}
        missingIdMessage={"Debe seleccionar una fila."}

        buttonTitle={vars.buttonTitle}
        buttonIcon={vars.buttonIcon}
        saveButton={vars.saveButton}
        closeButton={true}
      >
        <article>
        <h1>{this.state.Actividad}</h1>
        <div className="detalleActividad">
        {
          this.state.Detalle.split('\n').map((item, index)=><p className="mb-1" key={`reporte-${index+1}`}>{item}</p>)
        }
        </div>
        </article>
      </ParadigmaModal>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Bitacoras/Modal.js